// import React, { useEffect, useState } from 'react'
// import { Table, Input ,Spin} from 'antd'
// import './Dashboard.css'
// import { useNavigate } from 'react-router-dom'
// import axios from 'axios'
// import { DashboardList } from '../../AllAPI/AdminAPI'

// export default function Dashboard() {
//   const navigate = useNavigate()
//   const storedBranchId = sessionStorage.getItem('selected_branch')
//   const BoardingYear = sessionStorage.getItem('BoardingYear')
//   const [loading, setLoading] = useState(false)

//   // ------------------- Disable Back Button -------------------

//   useEffect(() => {
//     // Push a dummy state
//     window.history.pushState(null, null, window.location.href)

//     const handlePopState = () => {
//       // Push forward again
//       window.history.pushState(null, null, window.location.href)
//     }

//     window.addEventListener('popstate', handlePopState)

//     return () => {
//       window.removeEventListener('popstate', handlePopState)
//     }
//   }, [])

//   // ------------------- State for dashboard stats -------------------
//   const [dashboardData, setDashboardData] = useState([])

//   // ------------------- Fetch API Data -------------------
//   const fetchDashboardData = async () => {
//     try {
//       setLoading(true)

//       const response = await axios.get(
//         `${DashboardList}/${storedBranchId}/${BoardingYear}`,
//       )

//       setDashboardData(response.data)
//     } catch (error) {
//       console.error('Dashboard Data Error:', error)
//     } finally {
//       setLoading(false)
//     }
//   }

//   useEffect(() => {
//     fetchDashboardData()
//   }, [])

//   return (
//     <div className="dashboard-container">
//       <div className="row p-0 m-0 pb-5" style={{ backgroundColor: '#f2f7fd' }}>
//         <div className="col-12 col-md-1"></div>
//         <div className="col-12 col-md-10 p-md-5" >
//         <Spin spinning={loading} tip="Loading dashboard...">
//           <div className="row p-0 px-md-5 m-0 mb-5 pt-3 pt-md-0">
//           {/* =============Pending Count============== */}

//             <div className="col-12 col-md-4 mb-4">
//               <div className="stat-card grad-green">
//                 <h4>Apprv. Pending Reg Fee (Count)</h4>
//                 <p className="stat-number">
//                   {dashboardData.totalRegistrationFeePendingCount || 0}
//                 </p>
//               </div>
//             </div>

//             <div className="col-12 col-md-4 mb-4">
//               <div className="stat-card grad-green">
//                 <h4>Apprv. Pending Hostel Fee (Count)</h4>
//                 <p className="stat-number">
//                   {dashboardData.totalHostelFeePendingCount || 0}
//                 </p>
//               </div>
//             </div>

//            <div className="col-12 col-md-4 mb-4">
//               <div className="stat-card grad-green">
//                 <h4>Apprv. Pending Leaves (Count)</h4>
//                 <p className="stat-number">
//                   {dashboardData.pendingLeaveCount || 0}
//                 </p>
//               </div>
//             </div>

//              <div className="col-12 col-md-4 mb-4">
//               <div className="stat-card grad-green">
//                 <h4>Apprv. Pending Complaints (Count)</h4>
//                 <p className="stat-number">
//                   {dashboardData.pendingComplaints || 0}
//                 </p>
//               </div>
//             </div>

//           {/* =============Todays Count============== */}

//             <div className="col-12 col-md-4 mb-4">
//               <div className="stat-card grad-blue">
//                 <h4>Todays Hostel Fee (Rs.)</h4>
//                 <p className="stat-number">
//                   {dashboardData.todayHostelFee || 0}
//                 </p>
//               </div>
//             </div>

//             <div className="col-12 col-md-4 mb-4">
//               <div className="stat-card grad-blue">
//                 <h4>Todays Registration Fee (Rs.)</h4>
//                 <p className="stat-number">
//                   {dashboardData.todayRegistrationFee || 0}
//                 </p>
//               </div>
//             </div>

//             <div className="col-12 col-md-4 mb-4">
//               <div className="stat-card grad-blue">
//                 <h4>Todays Registration (Count)</h4>
//                 <p className="stat-number">
//                   {dashboardData.todayRegistrationCount || 0}
//                 </p>
//               </div>
//             </div>

//             <div className="col-12 col-md-4 mb-4">
//               <div className="stat-card grad-blue">
//                 <h4>Todays Leave (Count)</h4>
//                 <p className="stat-number">
//                   {dashboardData.todayLeaveCount || 0}
//                 </p>
//               </div>
//             </div>

//           {/* =============Total Count============== */}

//            <div className="col-12 col-md-4 mb-4">
//               <div className="stat-card grad-orange">
//                 <h4>Total Hostel Fee Approved (Count)</h4>
//                 <p className="stat-number">
//                   {dashboardData.totalHostelFeeApprovedCount || 0}
//                 </p>
//               </div>
//             </div>

//             <div className="col-12 col-md-4 mb-4">
//               <div className="stat-card grad-orange">
//                 <h4>Total Hostel Fee (Rs.)</h4>
//                 <p className="stat-number">
//                   {dashboardData.totalHostelFee || 0}
//                 </p>
//               </div>
//             </div>

//             <div className="col-12 col-md-4 mb-4">
//               <div className="stat-card grad-orange">
//                 <h4>Total Registration Fee (Rs.)</h4>
//                 <p className="stat-number">
//                   {dashboardData.totalRegistrationFee || 0}
//                 </p>
//               </div>
//             </div>

//             <div className="col-12 col-md-4 mb-4">
//               <div className="stat-card grad-orange">
//                 <h4>Total Concession Amount (Rs.)</h4>
//                 <p className="stat-number">
//                   {dashboardData.totalConcessionAmts || 0}
//                 </p>
//               </div>
//             </div>

//             <div className="col-12 col-md-4 mb-4">
//               <div className="stat-card grad-orange">
//                 <h4>Total Available Beds (Count)</h4>
//                 <p className="stat-number">
//                   {dashboardData.availableBedCount || 0}
//                 </p>
//               </div>
//             </div>

//           </div>
//           </Spin>
//         </div>
//         <div className="col-12 col-md-1"></div>
//       </div>
//     </div>
//   )
// }

import React, { useEffect, useState } from 'react'
import { Spin } from 'antd'
import './Dashboard.css'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { DashboardList } from '../../AllAPI/AdminAPI'

export default function Dashboard() {
  const navigate = useNavigate()
  const storedBranchId = sessionStorage.getItem('selected_branch')
  const BoardingYear = sessionStorage.getItem('BoardingYear')
  const [loading, setLoading] = useState(false)
  const [dashboardData, setDashboardData] = useState({})

  useEffect(() => {
    window.history.pushState(null, null, window.location.href)
    const handlePopState = () => {
      window.history.pushState(null, null, window.location.href)
    }
    window.addEventListener('popstate', handlePopState)
    return () => window.removeEventListener('popstate', handlePopState)
  }, [])

  const fetchDashboardData = async () => {
    try {
      setLoading(true)
      const response = await axios.get(
        `${DashboardList}/${storedBranchId}/${BoardingYear}`,
      )
      setDashboardData(response.data)
    } catch (error) {
      console.error('Dashboard Data Error:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchDashboardData()
  }, [])

  const fmt = (val) =>
    val !== undefined && val !== null ? val.toLocaleString('en-IN') : '0'

  return (
    <div className="db-page">
      <Spin spinning={loading} tip="Loading dashboard...">
        <div className="db-inner">
          {/* Header */}
          <div className="header-row">
            <h2 className="page-title">Dashboard</h2>
          </div>

          {/* ── Pending ─────────────────────────── */}
          <p className="section-label">Approval pending</p>
          <div className="stats-grid four-col">
            <StatCard
              accent="violet"
              label="Reg. Fee Pending"
              value={fmt(dashboardData.totalRegistrationFeePendingCount)}
              // meta="awaiting approval"
            />

            <StatCard
              accent="violet"
              label="Document Approval Pending"
              value={fmt(dashboardData.totalDocumentApprovalPending)}
              // meta="awaiting approval"
            />

            <StatCard
              accent="violet"
              label="Hostel Fee Pending"
              value={fmt(dashboardData.totalHostelFeePendingCount)}
              // meta="awaiting approval"
            />
            <StatCard
              accent="violet"
              label="Leave Requests Pending"
              value={fmt(dashboardData.pendingLeaveCount)}
              // meta="awaiting approval"
            />
            <StatCard
              accent="violet"
              label="Complaints Pending"
              value={fmt(dashboardData.pendingComplaints)}
              // meta="awaiting approval"
            />
            <StatCard
              accent="violet"
              label="Total Interview Pending"
              value={fmt(dashboardData.totalInterviewPendingCount)}
              // meta="awaiting approval"
            />
          </div>

          {/* ── Today ───────────────────────────── */}
          <p className="section-label">Today's activity</p>
          <div className="stats-grid four-col">
            <StatCard
              accent="blue"
              label="Hostel Fee Collected"
              value={`₹${fmt(dashboardData.todayHostelFee)}`}
              // meta="today"
            />
            <StatCard
              accent="blue"
              label="Registration Fee Collected"
              value={`₹${fmt(dashboardData.todayRegistrationFee)}`}
              // meta="today"
            />
            <StatCard
              accent="blue"
              label="New Registrations"
              value={fmt(dashboardData.todayRegistrationCount)}
              // meta="today"
            />
            <StatCard
              accent="blue"
              label="Leave Applications"
              value={fmt(dashboardData.todayLeaveCount)}
              // meta="today"
            />
          </div>

          {/* ── Totals ──────────────────────────── */}
          <p className="section-label">Overall summary</p>
          <div className="summary-row-wrap">
            <div className="summary-card">
              <h3 className="summary-card-title">Financials</h3>
              <SummaryRow
                label="Hostel Fee Approved (count)"
                value={fmt(dashboardData.totalHostelFeeApprovedCount)}
              />
              <SummaryRow
                label="Total Hostel Fee"
                value={`₹${fmt(dashboardData.totalHostelFee)}`}
              />
              <SummaryRow
                label="Total Registration Fee"
                value={`₹${fmt(dashboardData.totalRegistrationFee)}`}
              />
              <SummaryRow
                label="Total Concession Granted"
                value={`₹${fmt(dashboardData.totalConcessionAmts)}`}
              />
            </div>

            <div className="summary-card">
              <h3 className="summary-card-title">Occupancy</h3>
              <SummaryRow
                label="Available Beds"
                value={
                  <>
                    {fmt(dashboardData.availableBedCount)}
                    <span className="pill pill-green" style={{ marginLeft: 8 }}>
                      Open
                    </span>
                  </>
                }
              />
              <SummaryRow
                label="Occupied Beds"
                value={fmt(dashboardData.totalHostelFeeApprovedCount || 0)}
              />
            </div>
          </div>
        </div>
      </Spin>
    </div>
  )
}

function StatCard({ accent, label, value, meta }) {
  return (
    <div className="stat-card">
      <div className={`card-accent accent-${accent}`} />
      <p className="card-label">{label}</p>
      <p className="card-value">{value}</p>
      {meta && <p className="card-meta">{meta}</p>}
    </div>
  )
}

function SummaryRow({ label, value }) {
  return (
    <div className="s-row">
      <span className="s-label">{label}</span>
      <span className="s-value">{value}</span>
    </div>
  )
}
